export const VIEW_TYPES = {
  GRID: 'grid',
  LIST: 'list',
}
